import React from "react";
import { getField } from "../../util/DynamicItemUtils";

export default function DeniedIssuerAuditClient({ item }: any) {
  var companyFormatted = getField(item, "publiccompany").replace(",", "::");
  var url =
    "/oversight/international/denied-access-to-inspections?publiccompany=" +
    companyFormatted;

  return (
    <div>
      <p className="lead-text-lt">Denied Issuer Audit Client</p>
      <h3>{getField(item, "publiccompany")}</h3>
      <div className="hawk-row inline">
        {getField(item, "auditorname") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Auditor Name</div>
            <div className="lead-text-st">{getField(item, "auditorname")}</div>
          </div>
        )}
        {getField(item, "auditorlocations") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Auditor Locations</div>
            <div className="lead-text-st">
              {getField(item, "auditorlocations")}
            </div>
          </div>
        )}
      </div>
      {window.location.href.includes("oversight/international") ? (
        ""
      ) : (
        <a href={url} className="hawk-read-more">
          Read More
        </a>
      )}
    </div>
  );
}
